export const trunk = {
  field: {
    my_ip: 'My IP Address',
    zorra_ip: 'Zorra IP Address',
    type: 'Type'
  },

  type: {
    outgoing: 'Outgoing',
    caller: 'Caller',
    incoming: 'Incoming'
  },

  modal: {
    remove: {
      content: 'Are you sure you want to delete the trunk {name}?'
    }
  },

  button: {
    create: 'Create trunk'
  }
};
